import keyBy from 'lodash/keyBy'
import get from 'lodash/get'
import compact from 'lodash/compact'
import moment from 'moment-timezone'

import {
  CLEAR_ORDERS,
  FETCH_ALL_ORDERS_FAILED,
  FETCH_ALL_ORDERS_SUCCEDED,
  FETCH_ALL_ORDERS_REQUESTED,
  SET_ALL_ORDERS_FILTERS,
  FETCH_REFUND_ORDERS_REQUESTED,
  FETCH_REFUND_ORDERS_SUCCEDED,
  FETCH_REFUND_ORDERS_FAILED,
  SET_REFUND_ORDERS_FILTERS,
  REFUND_ORDER_SUCCEEDED,
  REFUND_ORDER_REQUESTED,
  REFUND_ORDER_FAILED,
  SET_ORDERS_API_PARAMS_CONFIG,
} from 'store/Orders/actionTypes'

const initialState = {
  byId: {},
  allOrders: {
    byId: {},
    filters: {
      searchBarWithSelect: {
        selectedSearchOptionUuid: 'orderNumber',
      },
    },
    paramsConfig: {
      page: 1,
      per: 100,
      fromDate: moment().startOf('day').tz('UTC').format(),
      toDate: moment().endOf('day').tz('UTC').format(),
    },
  },
  refundOrders: {},
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ALL_ORDERS_REQUESTED: {
      return {
        ...state,
        allOrders: {
          ...state.allOrders,
          isLoading: true,
        },
      }
    }

    case FETCH_ALL_ORDERS_SUCCEDED: {
      const data = payload?.data
      const total = Number(payload?.headers?.total) ?? 0

      return {
        ...state,
        allOrders: {
          ...state.allOrders,
          isLoading: false,
          byId: keyBy(data, 'uuid'),
          total,
        },
      }
    }

    case FETCH_ALL_ORDERS_FAILED: {
      return {
        ...state,
        allOrders: {
          ...state.allOrders,
          isLoading: false,
        },
      }
    }

    case SET_ALL_ORDERS_FILTERS: {
      return {
        ...state,
        allOrders: {
          ...state.allOrders,
          filters: {
            ...state.allOrders.filters,
            ...payload,
          },
        },
      }
    }

    case SET_ORDERS_API_PARAMS_CONFIG: {
      return {
        ...state,
        allOrders: {
          ...state.allOrders,
          paramsConfig: {
            ...state.allOrders.paramsConfig,
            ...payload,
          },
        },
      }
    }

    case FETCH_REFUND_ORDERS_REQUESTED: {
      return {
        ...state,
        refundOrders: {
          isLoading: true,
        },
      }
    }

    case FETCH_REFUND_ORDERS_SUCCEDED: {
      const mutations = compact(payload.refundMutations).map((mutation) => ({
        ...mutation.order,
        reason: mutation.reason,
        objectUuid: mutation.objectUuid,
        orderId: mutation.id,
        mutationLineItemUuids: get(
          mutation,
          'mutationPayload.lineItemUuids',
          []
        ),
        isPending: true,
      }))

      const orders = compact(payload.orders).map((order) => ({
        ...order,
        orderId: order.uuid,
      }))

      return {
        ...state,
        refundOrders: {
          ...state.refundOrders,
          isLoading: false,
          byId: { ...keyBy(orders, 'orderId'), ...keyBy(mutations, 'orderId') },
        },
      }
    }

    case FETCH_REFUND_ORDERS_FAILED: {
      return {
        ...state,
        refundOrders: {
          isLoading: false,
          err: payload,
        },
      }
    }

    case SET_REFUND_ORDERS_FILTERS: {
      return {
        ...state,
        refundOrders: {
          ...state.refundOrders,
          filters: {
            ...state.refundOrders.filters,
            ...payload,
          },
        },
      }
    }

    case CLEAR_ORDERS: {
      return {
        ...state,
        byId: initialState.byId,
      }
    }

    case REFUND_ORDER_REQUESTED: {
      return {
        ...state,
        refundOrders: {
          ...state.refundOrders,
          isLoading: true,
        },
      }
    }

    case REFUND_ORDER_SUCCEEDED: {
      return {
        ...state,
        refundOrders: {
          ...state.refundOrders,
          isLoading: false,
        },
      }
    }

    case REFUND_ORDER_FAILED: {
      return {
        ...state,
        refundOrders: {
          ...state.refundOrders,
          isLoading: false,
          err: payload,
        },
      }
    }

    default:
      return state
  }
}
